import React, { Fragment } from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { TickBox } from "../../../../libraries/ReportGenerator/TickBox";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";

export const NonCompliantLocomotiveBackToService = (props) => {
  const { reportData } = props;

  let reportByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  // let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportByDateAndUser);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportByDateAndUser);

  return (
    <Fragment>
      {decodedReports.map((report, index) => (
        <div
          key={index}
          className="mainContent table-report last-page-break-print"
          style={{ ...themeService(switchReportStyle.mainStyle) }}
        >
          <ViewReport data={report} {...props}></ViewReport>
        </div>
      ))}
    </Fragment>
  );
};

const ViewReport = (props) => {
  const { data } = props;
  const { decodedData } = data;

  return (
    <Fragment>
      {decodedData.map((singleReport, i) => {
        return (
          <Fragment key={i}>
            <ReportTitleSection title={props.title || "Non Compliant Locomotive Inspection Report"} fontSizeOverride={"35px"} />
            <ReportFraInfoSectionContainer {...props} />
            <span className="spacer"></span>
            <table style={{ border: "2px solid black" }}>
              <EqualContentsRow>
                <TickBox flag={singleReport.summary.checkedAll} label="Checked all locomotive Parts" />
                <TickBox flag={singleReport.summary.backtoservice} label="Return locomotive back to service" />
              </EqualContentsRow>
            </table>
            <table className="table-bordered">
              <ReportTableSectionRenderer
                rowsData={singleReport.summary}
                section={{
                  heights: { header1: "80px" },
                  classes: { header2: "" },
                  inlineData: true,
                  columns: [
                    {
                      title: "Additional Comments",
                      colSpan: 1,
                      rowSpan: 1,
                      topAlign: true,
                      leftAlign: true,
                      className: "tbl-text-normal",
                      accessor: "comments",
                    },
                  ],
                }}
              ></ReportTableSectionRenderer>
            </table>
          </Fragment>
        );
      })}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/NonCompliantLocomotiveBackToService/NonCompliantLocomotiveBackToService.jsx